/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2019-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React, {Component} from 'react';
import sharedConfig from '../../core/sharedConfig';
import './footer.scss';

class Footer extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="footer-row">
                <div className="col-xs-3"></div>
                <div className="col-xs-6 footer-cr"
                     data-testid="footer-text">Copyright &copy; {sharedConfig.copyrightYear} Corero
                    SmartWall&reg; Service
                    Portal{!this.props.hideVersion &&
                        <span data-testid="footer-version"> (v{sharedConfig.version})</span>}. All rights reserved.
                </div>
                <div className="col-xs-3"></div>
            </div>
        )
    }
}

export default Footer;
